import { AppSocket } from 'socket';
import { webSocketService } from './utils';

export const ws = new webSocketService('api/v4', 'updates');
export const automationWs = new webSocketService('api/v4', 'automation');

// Сокеты выше переделать на общий AppSocket
export const commonWS = AppSocket.getInstance({
  url: 'common/ws',
  debug: true,
});

export const callsWS = AppSocket.getInstance({
  url: 'common/calls',
  debug: true,
});
